import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { ToastProvider } from '@nexans/react-ui-kit'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Suspense } from 'react'

import { ScreenLoader } from '@/components/feedbacks'
import { queryClient } from '@/lib/react-query'
import { AnalyticsProvider, AuthProvider } from '@/providers'
import AppRoutes from '@/router/AppRoutes'

import { appInsightsPlugin } from './appInsights.ts'

function App() {
  return (
    <AppInsightsContext.Provider value={appInsightsPlugin}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools buttonPosition="bottom-right" initialIsOpen={false} />
        <AuthProvider>
          <ToastProvider autoCloseTime={5000} horizontalAlign="right" verticalAlign="top">
            <AnalyticsProvider>
              <Suspense fallback={<ScreenLoader />}>
                <AppRoutes />
              </Suspense>
            </AnalyticsProvider>
          </ToastProvider>
        </AuthProvider>
      </QueryClientProvider>
    </AppInsightsContext.Provider>
  )
}

export default App
